import { TaskApiFacade } from "./task.api-facade";
import { TaskStoreFacade } from "./task.store-facade";
import { Task } from "./task.model";
import { AccountObjectFacade } from "../account-object/account-object.facade";
import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { zip } from "rxjs/observable/zip";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class TaskFacade extends AccountObjectFacade<Task, TaskApiFacade, TaskStoreFacade> {

    onAfterReceiveApiObjects(objects: Array<Task>): Observable<Array<Task>> {
        return zip(...objects.map(task => this.onAfterReceiveApiObject(task)));
    }

    protected updateStore(remote: Array<Task>, local: Array<Task>, options?: ApiRequestOptions): void {
        this.updateStoreDefault(remote, local, options);
    }

    protected getApiAllByAccount(accountId, options?: ApiRequestOptions): Observable<Array<Task>> {
        return this.appFacade.objects.task.store
            .getFilters()
            .take(1)
            .concatMap(filters => {
                return this.api.getFiltered(accountId, filters as any, options)
                    .map(response => {
                        this.store.setTotal(response.total);
                        return response.items;
                    });
            });
    }

    protected onAfterReceiveApiObject(task: Task): Observable<Task> {
        return this.appFacade.objects.job.store.get(task.job)
            .take(1)
            .concatMap(job => {

                if (job) {
                    return of(undefined);
                }
                console.log("task facade syncing job", task.job);
                return this.appFacade.objects.job.syncOne(task.account, task.job).take(1);
            })
            .map(() => task);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task/task.facade.ts